import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-link-1-6-0{background-color:transparent;color:#00b5e2;font-weight:400;text-decoration:none}.hcr-link-1-6-0:active,.hcr-link-1-6-0:focus,.hcr-link-1-6-0:hover{color:#00b5e2;text-decoration:underline}",
map:{"hcr-link":"hcr-link-1-6-0"}};

var bem = Bem('link', styles);
var Link = function Link(_ref) {
  var children = _ref.children,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["children", "extraClasses"]);

  return React.createElement("a", _extends({
    className: bem.b(false, extraClasses)
  }, rest), children);
};
Link.displayName = 'Link';
Link.defaultProps = {
  extraClasses: ''
};
Link.propTypes = {
  /** Content of the link */
  children: PropTypes.node.isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string
};
var link = Injecss(Link, styles);

export { link as Link };
